
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../utils/withRouter';
import Loader from '../../utils/Loader'
import { fill_action } from '../../actions/fillList_action';
import { booking_Details_action, get_booking_Details_action, delete_table_booking_Details_action, getPriceAndTime_action, check_meeting_slots_action } from '../../actions/bookingDetails_action/bookingDetails_action';
import { TypeOfEventActionId, EntryTypeActionId, SittingArrangementActionId, DeskActionId, toastError, currencyActionId, sessionExpireMessage, tokenInavlidMessage } from '../../utils/constants';
import Header from '../../common_components/Header';
import BookingDetailsAside from '../../common_components/booking_details/bookingDetailsAside';
import Steps from '../../common_components/booking_details/steps';
import { ToastContainer, toast, } from 'react-toastify';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import 'react-datepicker/dist/react-datepicker.css';
import { TimePicker } from '@hilla/react-components/TimePicker.js';
import { update_additional_hour, } from "../../actions/myOrders_action/myOrders_action";
class BookingDetails extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      checkboxFlag: sessionStorage.getItem('checkboxFlag'),
      TypeOfEventId: '',
      TypeOfEventList: [],
      EntryTypeId: '',
      EntryTypeList: [],
      SittingArrangementId: '',
      SittingArrangementList: [],
      DeskId: '',
      DeskList: [],
      bookingList: JSON.parse(sessionStorage.getItem('bookArray')),
      NoofPAX: '',
      UserId: '',
      membership: '',
      formFile: '',
      formFileType: '',
      fileName: '',
      membershipFilePath: '',
      companyDisable: true,
      newBookingList: [],
      Is_CenterID: false,
      currencyId: 1,
      currencyList: [],
      is_Details: false,
      CenterID: '',
      OrderID: '',
      LastDate: '',
      MaxPAX: '',
      dummyFileName: '',

      // possesion
      PossesionStartDate: '',
      PossesionEndDate: '',
      PossesionStartTime: '',
      PossesionEndTime: '',

      // event
      eventStartDate: '',
      eventEndDate: '',
      eventStartTime: '',
      eventEndTime: '',

      // Dismantle
      dismantleStartDate: '',
      dismantleEndDate: '',
      dismantleStartTime: '',
      dismantleEndTime: '',

      modalShowDateErr: '',
      slotStartDate: '',
      slotEndDate: '',
      TypeOfEventErr: '',
      SittingTypeErr: '',

      endTimeSlot: '',
      modalShowTimeErr: '',
      slotEventEndDate: '',

      isOpen: false,
      comparDataWithSessionList: [],
      MembershipFilePathDetails: '',

      checkedPossessionFromDate: '',
      checkedPossessionToDate: '',
      checkedPossessionFromTime: '',
      checkedPossessionToTime: '',

      checkedEventFromDate: '',
      checkedEventToDate: '',
      checkedEventFromTime: '',
      checkedEventToTime: '',

      checkedDismantleFromDate: '',
      checkedDismantleToDate: '',
      checkedDismantleFromTime: '',
      checkedDismantleToTime: '',

      isOpen2: false,
      eventFromTimeList: [],
      eventToTimeList: [],
      //check slots
      slotDataList: [],
      PricingList: []
    }
    this.TypeOfEventId = this.TypeOfEventId.bind(this)
    this.SittingArrangementId = this.SittingArrangementId.bind(this)
    this.getFillList = this.getFillList.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.checkbox = this.checkbox.bind(this)
    this.companyInfo = this.companyInfo.bind(this)
    this.getBookingDetails = this.getBookingDetails.bind(this)
    this.isDateDisabled = this.isDateDisabled.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
    this.toggleModal2 = this.toggleModal2.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {

    console.log('log12345----', JSON.parse(sessionStorage.getItem('bookArray')))

    if (JSON.parse(sessionStorage.getItem('UserLoginData')) == null) {
      setTimeout(() => {
        this.props.navigate('/login')
      }, 500);
    }
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ?
          this.props.navigate('/checkList') :
          <></>
      }
    }, 10);

    setTimeout(() => {
      console.log("sessionStorage.getItem(getDetailsFileName)", sessionStorage.getItem("getDetailsFileName"))
      console.log("sessionStorage.getItem(checkboxFlag)", sessionStorage.getItem('checkboxFlag'))
      console.log("sessionStorage.getItem(fileName)", sessionStorage.getItem('fileName'))
      console.log("bookingListJSON", JSON.parse(sessionStorage.getItem('bookArray')))
    }, 100);

    this.getFillList(TypeOfEventActionId, '', '', '')
    this.getFillList(EntryTypeActionId, '', '', '')
    this.getFillList(DeskActionId, '', '', '')
    this.getFillList(currencyActionId, '', '', '')


    setTimeout(() => {
      console.log("booking Details", this.props)
    }, 300);

    this.setState({

      is_Details: this.props.location.state != null && this.props.location.state.is_Details != null ? this.props.location.state.is_Details : false,

      Is_CenterID: this.props.location.state != null && this.props.location.state.Is_CenterID != null ? this.props.location.state.Is_CenterID : false,

      OrderID: this.props.location.state != null && this.props.location.state.OrderID != null ? this.props.location.state.OrderID : '',

      ClientID: this.props.location.state != null && this.props.location.state.ClientID != null ? this.props.location.state.ClientID : '',

      CenterID: this.props.location.state != null && this.props.location.state.CenterID != null ? this.props.location.state.CenterID : '',

    })

    setTimeout(() => {
      const CenterID = this.props.location.state != null && this.props.location.state.CenterID != null ? this.props.location.state.CenterID : ''
      this.getFillList(SittingArrangementActionId, parseInt(sessionStorage.getItem('userId')), CenterID, '')
    }, 100);

    sessionStorage.getItem('userId') != null && sessionStorage.getItem('userId') != '' && this.props.location.state != null && this.props.location.state.OrderID != '' ? this.getBookingDetails() : <></>

    sessionStorage.getItem('userId') != null && sessionStorage.getItem('userId') != '' && this.props.location.state.OrderID == '' ? this.bookingArrayDateCondition() : <></>

    sessionStorage.getItem('userId') != null && sessionStorage.getItem('userId') != '' && this.props.location.state.OrderID == '' ? this.checkedBookingArrayDateTimeCondition() : <></>

    this.getPriceAndTime()
    setTimeout(() => {
      if (this.state.bookingList[0]['CenterName'] == 'MEETING LOUNGE') {
        const array = []
        this.state.bookingList.map((item) => {
          array.push(
            {
              EventStartDate: moment(item.EventStartDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
              EventEndDate: moment(item.EventEndDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
            }
          )
        })
        this.checkMeetingSlot(array)
      }
    }, 2000);
  }

  getPriceAndTime() {
    const CenterID = this.props.location.state != null && this.props.location.state.CenterID != null ? this.props.location.state.CenterID : ''
    this.props
      .getPriceAndTime_action(CenterID)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false, PricingList: data.data })
        }
        else {
          if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false })
            toast.error(data.msg, {
              position: "top-center",
              theme: 'colored',
              autoClose: 3000,
              hideProgressBar: true,
            })
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  checkMeetingSlot(checkSlotList) {
    const CenterID = this.props.location.state != null && this.props.location.state.CenterID != null ? this.props.location.state.CenterID : null
    const OrderID = this.props.location.state != null && this.props.location.state.OrderID != null ? this.props.location.state.OrderID : null
    console.log("checkSlotList---", checkSlotList)
    this.props
      .check_meeting_slots_action(CenterID, OrderID, checkSlotList != '' ? checkSlotList : null)
      .then((data) => {
        if (data.error != 1) {
          const array = []
          data.data.slotData.map((item) => {
            array.push(
              {
                start: item.EventStartTime,
                end: item.EventEndTime,
              }
            )
          })
          this.setState({
            isLoading: false,
            slotDataList: array
          })
        }
        else {
          if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false })
            toast.error(data.msg, {
              position: "top-center",
              theme: 'colored',
              autoClose: 3000,
              hideProgressBar: true,
            })
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  roundToQuarterHour(date) {
    const roundedDate = new Date(date);
    const minutes = roundedDate.getMinutes();
    const roundedMinutes = Math.round(minutes / 15) * 15;
    roundedDate.setMinutes(roundedMinutes);
    return roundedDate;
  };

  insertOvernightCharges(orderId, charges) {
    this.props
      .update_additional_hour(orderId, 0, 0, charges)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false })
        }
        else {
          if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false })
            toast.error(data.msg, {
              position: "top-center",
              theme: 'colored',
              autoClose: 3000,
              hideProgressBar: true,
            })
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  bookingArrayDateCondition() {
    const { bookingList } = this.state

    if (bookingList != '' && bookingList != null) {
      bookingList.sort((a, b) => a.id - b.id)
      this.setState({
        slotStartDate: moment(bookingList[0]['Date'], "DD/MM/YYYY").toDate(),
        PossesionStartDate: moment(bookingList[0]['Date'], "DD/MM/YYYY").toDate(),
        PossesionEndDate: moment(bookingList[0]['Date'], "DD/MM/YYYY").toDate(),
        eventStartDate: moment(bookingList[0]['Date'], "DD/MM/YYYY").toDate(),
      })
      bookingList.map((item, i) => {
        // console.log("bookingList item--------", item)
        if (i == 0) {
          var timeSplit = item.Timeslot.split('-')
          var startTime = timeSplit[0].trim().split(/\s+(?:AM|PM)/)
          var endTime = timeSplit[1].trim().split(/\s+(?:AM|PM)/)

          const checked24hrsFromTime = this.caluculatesTimes(startTime[0], item.PreSessionTime, 0)

          const possessionFromTime = checked24hrsFromTime == '24:00' ? '00:00' : checked24hrsFromTime
          console.log("startTime-------------------------------------------123------------------", checked24hrsFromTime)

          // item.EventStartTime = possessionFromTime

          this.setState({ PossesionStartTime: startTime[0], PossesionEndTime: possessionFromTime, eventStartTime: startTime[0], })
        }

        console.log("bookingList item--------", item.Timeslot)
        item.EventStartTime = ''
        item.EventEndTime = ''

        const allEventTimeSplit = item.Timeslot.split('-')
        const allEventStartTime = allEventTimeSplit[0].trim().split(/\s+(?:AM|PM)/)
        const allEventEndTime = allEventTimeSplit[1].trim().split(/\s+(?:AM|PM)/)

        const FromTime24hrs = this.caluculatesTimes(allEventStartTime[0], item.PreSessionTime, 0)
        const toTime24hrs = this.caluculatesTimes(allEventEndTime[0], item.PostSessionTime, 1)
        const eventFromTime = FromTime24hrs == '24:00' ? '00:00' : FromTime24hrs
        const eventToTime = toTime24hrs == '24:00' ? '00:00' : toTime24hrs
        // item.EventStartTime = eventFromTime
        // item.EventEndTime = eventToTime

        if (i + 1 == bookingList.length) {
          var timeSplit = item.Timeslot.split('-')
          var startTime = timeSplit[0].trim().split(/\s+(?:AM|PM)/)
          var endTime = timeSplit[1].trim().split(/\s+(?:AM|PM)/)

          const checked24hrsToTime = this.caluculatesTimes(endTime[0], item.PostSessionTime, 1)

          const dismantleToTime = checked24hrsToTime == '24:00' ? '00:00' : checked24hrsToTime
          // item.EventEndTime = dismantleToTime
          console.log("dismantleToTime---------------", dismantleToTime)
          this.setState({ dismantleStartTime: dismantleToTime, dismantleEndTime: endTime[0], eventEndTime: endTime[0], })
        }

        var data = 1 + i++
        if (data == bookingList.length) {
          const endDate = moment(item.Date, "DD/MM/YYYY").toDate()
          const newDate = new Date(endDate)
          newDate.setDate(endDate.getDate() + 1)
          this.setState({
            dismantleStartDate: endDate,
            dismantleEndDate: endDate,
            eventEndDate: endDate,
            slotEventEndDate: newDate,
            slotEndDate: endDate
          })
        }
      })
      this.setState({ bookingList: bookingList })
    }
  }

  checkedBookingArrayDateTimeCondition() {
    const { bookingList } = this.state

    if (bookingList != '' && bookingList != null) {
      this.setState({
        checkedPossessionFromDate: moment(bookingList[0]['Date'], "DD/MM/YYYY").toDate(),
        checkedPossessionToDate: moment(bookingList[0]['Date'], "DD/MM/YYYY").toDate(),
        checkedEventFromDate: moment(bookingList[0]['Date'], "DD/MM/YYYY").toDate(),
        slotStartDate: moment(bookingList[0]['Date'], "DD/MM/YYYY").toDate(),
        // PossesionStartDate: moment(bookingList[0]['Date'], "DD/MM/YYYY").toDate(),
        // PossesionEndDate: moment(bookingList[0]['Date'], "DD/MM/YYYY").toDate(),
        eventStartDate: moment(bookingList[0]['Date'], "DD/MM/YYYY").toDate(),
      })
      // console.log("slotStartDate-------------------------------------------------------------", this.state.slotStartDate)
      bookingList.map((item, i) => {
        if (i == 0) {
          var timeSplit = item.Timeslot.split('-')
          var startTime = timeSplit[0].trim().split(/\s+(?:AM|PM)/)
          var endTime = timeSplit[1].trim().split(/\s+(?:AM|PM)/)

          const checked24hrsFromTime = this.caluculatesTimes(startTime[0], item.PreSessionTime, 0)

          const possessionFromTime = checked24hrsFromTime == '24:00' ? '00:00' : checked24hrsFromTime



          this.setState({ checkedPossessionFromTime: startTime[0], checkedPossessionToTime: possessionFromTime, checkedEventFromTime: startTime[0], })
        }

        const allEventTimeSplit = item.Timeslot.split('-')
        const allEventStartTime = allEventTimeSplit[0].trim().split(/\s+(?:AM|PM)/)
        const allEventEndTime = allEventTimeSplit[1].trim().split(/\s+(?:AM|PM)/)

        const FromTime24hrs = this.caluculatesTimes(allEventStartTime[0], item.PreSessionTime, 0)
        const toTime24hrs = this.caluculatesTimes(allEventEndTime[0], item.PostSessionTime, 1)
        const eventFromTime = FromTime24hrs == '24:00' ? '00:00' : FromTime24hrs
        const eventToTime = toTime24hrs == '24:00' ? '00:00' : toTime24hrs

        this.state.eventFromTimeList.push(eventFromTime)
        this.state.eventToTimeList.push(eventToTime)

        if (i + 1 == bookingList.length) {
          var timeSplit = item.Timeslot.split('-')
          var startTime = timeSplit[0].trim().split(/\s+(?:AM|PM)/)
          var endTime = timeSplit[1].trim().split(/\s+(?:AM|PM)/)

          const checked24hrsToTime = this.caluculatesTimes(endTime[0], item.PostSessionTime, 1)

          const dismantleToTime = checked24hrsToTime == '24:00' ? '00:00' : checked24hrsToTime
          console.log("dismantleToTime---------------", dismantleToTime)
          this.setState({ checkedDismantleFromTime: dismantleToTime, checkedDismantleToTime: endTime[0], checkedEventToTime: endTime[0] })
        }

        var data = 1 + i++
        if (data == bookingList.length) {
          const endDate = moment(item.Date, "DD/MM/YYYY").toDate()
          const newDate = new Date(endDate)
          newDate.setDate(endDate.getDate() + 1)
          this.setState({
            checkedDismantleFromDate: endDate, checkedDismantleToDate: endDate, checkedEventToDate: endDate, slotEventEndDate: newDate,
            slotEndDate: endDate, eventEndDate: endDate
          })
        }
      })

    }
  }

  caluculatesTimes(time1, time2, flag) {
    console.log("time1---------", time1)
    console.log("time2---------", time2)
    if (time1 != undefined && time2 != undefined) {
      // Convert time strings to minutes
      var minutes1 = parseInt(time1.split(":")[0]) * 60 + parseInt(time1.split(":")[1]);
      var minutes2 = parseInt(time2.split(":")[0]) * 60 + parseInt(time2.split(":")[1]);

      // Add the minutes
      var totalMinutes = flag == 1 ? minutes1 - minutes2 : minutes1 + minutes2;

      // Convert back to "hh:mm" format
      var hours = Math.floor(totalMinutes / 60);
      var minutes = totalMinutes % 60;

      // Format hours and minutes with leading zeros
      var result = (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes;

      return result;
    }
  }

  TypeOfEventId(e) {

    this.setState({ TypeOfEventId: e.target.value, TypeOfEventErr: '' })

  }

  SittingArrangementId(e, index) {
    const { SittingArrangementList } = this.state
    const value = e.target.checked
    SittingArrangementList.map((item, i) => {
      if (i === index) {
        if (value) {
          item.IS_cheked = 1
          this.setState({ SittingArrangementId: item.SittingTypeID, SittingTypeErr: '' })
        }
      } else {
        item.IS_cheked = 0
      }
    })

    this.setState({ SittingArrangementList: SittingArrangementList })
  }

  currencyId(e) {
    this.setState({ currencyId: e.target.value })
  }

  getFillList(value, userID, keyword, keyvalue) {
    this.setState({ isLoading: true })
    this.props
      .fill_action(value, (userID == '' || userID == null) ? null : userID, keyword != '' ? keyword : null, keyvalue != '' ? keyvalue : null)
      .then((data) => {
        if (data.error != 1) {
          if (value == TypeOfEventActionId) {
            this.setState({ TypeOfEventList: data.data, isLoading: false })
            console.log("TypeOfEventIdBDL", data.data)
          }
          if (value == EntryTypeActionId) {
            this.setState({ EntryTypeList: data.data, isLoading: false })
          }
          if (value == SittingArrangementActionId) {
            data.data.map(item => {
              item.IS_cheked = 0
            })
            this.setState({ SittingArrangementList: data.data, isLoading: false })
            console.log("SittingArrangementActionId", data.data)
          }
          if (value == DeskActionId) {
            this.setState({ DeskList: data.data, isLoading: false })
          }
          if (value == currencyActionId) {
            this.setState({ currencyList: data.data, isLoading: false })

          }
        }
      })
      .catch((e) => {
        console.log(e);
      });

  }

  handleDelete(e, CalendarID, date) {
    e.preventDefault()
    const { bookingList } = this.state

    var flagMSG = false

    // var checkedMultipleDate = bookingList.filter(data => data.Date == date);

    const DateArray = sessionStorage.getItem('validationDateList')

    console.log("DateArray", DateArray)

    const dateList = []

    for (var i = 0; i < bookingList.length - 1; i++) {

      var lastIndex = bookingList[bookingList.length - 1]['CalendarID']

      if (bookingList[0]['CalendarID'] == CalendarID || lastIndex == CalendarID) {

        var list = bookingList.filter(data => data.CalendarID != CalendarID);

        if (bookingList[i]['Date'] == bookingList[i + 1]['Date']) {
          dateList.push(bookingList[i]['Date'])
        }

        sessionStorage.setItem('bookArray', JSON.stringify(list))


        this.setState({
          Is_CenterID: false,
          bookingList: list,
        }, () => { })

        if (list.length == 0) {
          sessionStorage.removeItem('bookArray')
          sessionStorage.removeItem('validationDateList')
        }

        flagMSG = true
      } else {


        flagMSG = false

      }
    }

    sessionStorage.setItem("validationDateList", JSON.stringify(dateList))

    setTimeout(() => {
      console.log("validationDateList 12345-----------", sessionStorage.getItem("validationDateList"))
    }, 200);

    if (flagMSG == true) {
      toast.success("Slot deleted successfully", {
        position: "top-center",
        theme: 'colored',
        autoClose: 3000,
        hideProgressBar: true,
      })
    }

    setTimeout(() => {
      this.bookingArrayDateCondition()
    }, 100);

  };

  checkTimeRanges(predefinedRanges, newRanges) {
    console.log("predefinedRanges---", predefinedRanges)
    console.log("newRanges---", newRanges)
    // Convert time string to minutes
    function timeToMinutes(time) {
      const [hours, minutes] = time.split(":").map(Number);
      return hours * 60 + minutes;
    }


    // Check for overlapping intervals
    function isOverlap(range1, range2) {
      const start1 = timeToMinutes(range1.start)
      const end1 = timeToMinutes(range1.end)
      const start2 = timeToMinutes(range2.start);
      const end2 = timeToMinutes(range2.end);
      console.log("start1---", start1)
      console.log("end1---", end1)
      console.log("start2---", start2)
      console.log("end2---", end2)
      // console.log("1---", start1 < end2 && end1 > start2)
      // console.log("2---", 540 >= start2 && 1020 <= end2)
      // console.log("3---", 540 <= start2 && 1020 >= end2)
      // console.log("4---", start1 < end2 && end1 > start2 && 540 >= start2 && 1020 <= end2)
      // console.log("5---", start1 < end2 && end1 > start2 && 540 <= start2 && 1020 >= end2)
      if (540 <= start2 && 1020 >= end2) {
        return ((start1 - 120) < end2 && (end1 + 120) > start2);
      } else {
        return true
      }
    }

    // Check if any of the new time ranges overlap with predefined ranges
    for (const newRange of newRanges) {
      for (const range of predefinedRanges) {
        if (isOverlap(range, newRange)) {
          return true;
        }
      }
    }

    return false;
  }

  handleSubmit(event) {
    event.preventDefault();
    const { TypeOfEventId, EntryTypeId, NoofPAX, SittingArrangementId, DeskId, checkboxFlag, membershipFilePath, bookingList, formFile, formFileType, fileName, currencyId, PossesionStartDate, PossesionEndDate, eventStartDate, eventEndDate, dismantleStartDate, dismantleEndDate, PossesionStartTime, PossesionEndTime, eventStartTime, eventEndTime, dismantleStartTime, dismantleEndTime, MembershipFilePathDetails, slotDataList } = this.state
    // this.props.navigate("/dashboard");
    const array = []
    bookingList.map((item) => {
      array.push(
        {
          start: item.EventStartTime,
          end: item.EventEndTime,
        }
      )
    })


    const OrderID = this.props.location.state != null && this.props.location.state.OrderID != null ? this.props.location.state.OrderID : ''

    const ClientID = this.props.location.state != null && this.props.location.state.ClientID != null ? this.props.location.state.ClientID : ''

    const CenterID = this.props.location.state != null && this.props.location.state.CenterID != null ? this.props.location.state.CenterID : ''

    const isEdit = this.props.location.state != null && this.props.location.state.isEdit != null ? this.props.location.state.isEdit : null

    console.log("eventEndDate *********************** 22222222223333333", eventEndDate)

    const possChargeStartDate = PossesionStartDate != '' && PossesionStartDate != null ? moment(PossesionStartDate, "ddd MMM DD YYYY HH:mm:ss [GMT]Z (India Standard Time)").format("DD-MM-YYYY") : null
    const possChargeEndDate = PossesionEndDate != '' && PossesionEndDate != null ? moment(PossesionEndDate, "ddd MMM DD YYYY HH:mm:ss [GMT]Z (India Standard Time)").format("DD-MM-YYYY") : null
    const disChargeStartDate = dismantleStartDate != '' && dismantleStartDate != null ? moment(dismantleStartDate, "ddd MMM DD YYYY HH:mm:ss [GMT]Z (India Standard Time)").format("DD-MM-YYYY") : null
    const disChargeEndDate = dismantleEndDate != '' && dismantleEndDate != null ? moment(dismantleEndDate, "ddd MMM DD YYYY HH:mm:ss [GMT]Z (India Standard Time)").format("DD-MM-YYYY") : null
    const eventChargeStartDate = eventStartDate != '' && eventStartDate != null ? moment(eventStartDate, "ddd MMM DD YYYY HH:mm:ss [GMT]Z (India Standard Time)").format("DD-MM-YYYY") : null
    const eventChargeEndDate = eventEndDate != '' && eventEndDate != null ? moment(eventEndDate, "ddd MMM DD YYYY HH:mm:ss [GMT]Z (India Standard Time)").format("DD-MM-YYYY") : null

    const newBookingList = []
    {
      bookingList != null && bookingList != '' ?
        bookingList.map(data => {
          {
            currencyId == 2 ?
              newBookingList.push({
                "CalendarID": data.CalendarID,
                "CenterID": data.CenterID,
                "TimeslotID": data.TimeslotID,
                "NoOfhrs": data.SelectedHr,
                "Price": data.PriceInUSD,
                "DiscountAmount": data.DiscountpriceInUSD,
                "NetAmount": data.NetpriceInUSD,
                "PossessionStartDate": PossesionStartDate != '' && PossesionStartDate != null ? moment(PossesionStartDate, "ddd MMM DD YYYY HH:mm:ss [GMT]Z (India Standard Time)").format("DD-MM-YYYY") : null,
                "PossessionEndDate": PossesionEndDate != '' && PossesionEndDate != null ? moment(PossesionEndDate, "ddd MMM DD YYYY HH:mm:ss [GMT]Z (India Standard Time)").format("DD-MM-YYYY") : null,
                "PossessionStartTime": PossesionStartTime,
                "PossessionEndTime": PossesionEndTime,
                "EventStartDate": data.EventStartDate,
                "EventEndDate": data.EventEndDate,
                "EventStartTime": data.EventStartTime.replace(/\s+(?:AM|PM)/, ""),
                "EventEndTime": data.EventEndTime.replace(/\s+(?:AM|PM)/, ""),
                "DismentalStartDate": dismantleStartDate != '' && dismantleStartDate != null ? moment(dismantleStartDate, "ddd MMM DD YYYY HH:mm:ss [GMT]Z (India Standard Time)").format("DD-MM-YYYY") : null,
                "DismentalEndDate": dismantleEndDate != '' && dismantleEndDate != null ? moment(dismantleEndDate, "ddd MMM DD YYYY HH:mm:ss [GMT]Z (India Standard Time)").format("DD-MM-YYYY") : null,
                "DismentalStartTime": dismantleStartTime,
                "DismentalEndTime": dismantleEndTime,
              })
              :
              newBookingList.push({
                "CalendarID": data.CalendarID,
                "CenterID": data.CenterID,
                "TimeslotID": data.TimeslotID,
                "NoOfhrs": data.SelectedHr,
                "Price": data.PriceInINR,
                "DiscountAmount": data.DiscountpriceInINR,
                "NetAmount": data.NetpriceInINR,
                "PossessionStartDate": PossesionStartDate != '' && PossesionStartDate != null ? moment(PossesionStartDate, "ddd MMM DD YYYY HH:mm:ss [GMT]Z (India Standard Time)").format("DD-MM-YYYY") : null,
                "PossessionEndDate": PossesionEndDate != '' && PossesionEndDate != null ? moment(PossesionEndDate, "ddd MMM DD YYYY HH:mm:ss [GMT]Z (India Standard Time)").format("DD-MM-YYYY") : null,
                "PossessionStartTime": PossesionStartTime,
                "PossessionEndTime": PossesionEndTime,
                "EventStartDate": data.EventStartDate,
                "EventEndDate": data.EventEndDate,
                "EventStartTime": data.EventStartTime.replace(/\s+(?:AM|PM)/, ""),
                "EventEndTime": data.EventEndTime.replace(/\s+(?:AM|PM)/, ""),
                "DismentalStartDate": dismantleStartDate != '' && dismantleStartDate != null ? moment(dismantleStartDate, "ddd MMM DD YYYY HH:mm:ss [GMT]Z (India Standard Time)").format("DD-MM-YYYY") : null,
                "DismentalEndDate": dismantleEndDate != '' && dismantleEndDate != null ? moment(dismantleEndDate, "ddd MMM DD YYYY HH:mm:ss [GMT]Z (India Standard Time)").format("DD-MM-YYYY") : null,
                "DismentalStartTime": dismantleStartTime,
                "DismentalEndTime": dismantleEndTime,
              })
          }
        }) : <></>
    }
    console.log("newBookingList", newBookingList)

    // possession
    const checkPossessionStartDate = newBookingList.every(item => item.PossessionStartDate != '' && item.PossessionStartDate != null)
    const checkPossessionEndDate = newBookingList.every(item => item.PossessionEndDate != '' && item.PossessionEndDate != null)
    const checkPossessionStartTime = newBookingList.every(item => item.PossessionStartTime != '' && item.PossessionStartTime != null)
    const checkPossessionEndTime = newBookingList.every(item => item.PossessionEndTime != '' && item.PossessionEndTime != null)

    // event
    const checkEventStartDate = newBookingList.every(item => item.EventStartDate != '' && item.EventStartDate != null)
    const checkEventEndDate = newBookingList.every(item => item.EventEndDate != '' && item.EventEndDate != null)
    const checkEventStartTime = newBookingList.every(item => item.EventStartTime != '' && item.EventStartTime != null)
    const checkEventEndTime = newBookingList.every(item => item.EventEndTime != '' && item.EventEndTime != null)

    // event
    const checkDismantleStartDate = newBookingList.every(item => item.DismentalStartDate != '' && item.DismentalStartDate != null)
    const checkDismantleEndDate = newBookingList.every(item => item.DismentalEndDate != '' && item.DismentalEndDate != null)
    const checkDismantleStartTime = newBookingList.every(item => item.DismentalStartTime != '' && item.DismentalStartTime != null)
    const checkDismantleEndTime = newBookingList.every(item => item.DismentalEndTime != '' && item.DismentalEndTime != null)

    this.inputValidate()
    setTimeout(() => {
      if (TypeOfEventId != '' && TypeOfEventId != null && TypeOfEventId != 'Select' && SittingArrangementId != '' && SittingArrangementId != null && SittingArrangementId != 'Select') {
        // if (checkPossessionStartDate) {
        //   if (checkPossessionEndDate) {
        //     if (checkPossessionStartTime) {
        //       if (checkPossessionEndTime) {

        if (checkEventStartDate) {
          if (checkEventEndDate) {
            if (checkEventStartTime) {
              if (checkEventEndTime) {

                // if (checkDismantleStartDate) {
                //   if (checkDismantleEndDate) {
                //     if (checkDismantleStartTime) {
                //       if (checkDismantleEndTime) {
                const checkTime = this.checkTimeRanges(slotDataList, array)
                console.log("checkTime---", checkTime)
                if (!checkTime) {
                  this.props
                    .booking_Details_action(OrderID,
                      TypeOfEventId, EntryTypeId, NoofPAX, SittingArrangementId,
                      DeskId, currencyId != 2 ? 1 : 2,
                      sessionStorage.getItem('formFile') != '' && sessionStorage.getItem('formFile') != null ? 1 : MembershipFilePathDetails != '' ? 1 : 0,
                      MembershipFilePathDetails,
                      newBookingList, ClientID,
                      sessionStorage.getItem('formFile') != '' ? sessionStorage.getItem('formFile') : null,
                      sessionStorage.getItem('formFile') != '' ? sessionStorage.getItem('membershipFormFileType') : null,
                      sessionStorage.getItem('fileName') != '' ? sessionStorage.getItem('fileName') : null,
                      isEdit != '' && isEdit != null ? isEdit : 0
                    )
                    .then((data) => {
                      if (data.error != 1) {
                        this.setState({ isLoading: false })
                        console.log("eventChargeStartDate---------", eventChargeStartDate)
                        console.log("possChargeStartDate---------", possChargeStartDate)
                        console.log("possChargeEndDate---------", possChargeEndDate)
                        console.log("disChargeStartDate---------", disChargeStartDate)
                        console.log("disChargeEndDate---------", disChargeEndDate)
                        console.log("eventChargeEndDate---------", eventChargeEndDate)
                        sessionStorage.removeItem('bookArray')
                        // if (currencyId == 1) {

                        //   if (possChargeStartDate != eventChargeStartDate && disChargeStartDate != eventChargeEndDate) {
                        //     this.insertOvernightCharges(data.data[0]['OrderID'], (data.data[0]['ChargesINR'] + data.data[0]['ChargesINR']))
                        //   } else if (possChargeStartDate != eventChargeStartDate && disChargeEndDate != eventChargeEndDate) {
                        //     this.insertOvernightCharges(data.data[0]['OrderID'], (data.data[0]['ChargesINR'] + data.data[0]['ChargesINR']))
                        //   } else if (possChargeStartDate != eventChargeStartDate) {
                        //     this.insertOvernightCharges(data.data[0]['OrderID'], data.data[0]['ChargesINR'])
                        //   } else if (possChargeEndDate != eventChargeStartDate) {
                        //     this.insertOvernightCharges(data.data[0]['OrderID'], data.data[0]['ChargesINR'])
                        //   } else if (disChargeStartDate != eventChargeEndDate) {
                        //     this.insertOvernightCharges(data.data[0]['OrderID'], data.data[0]['ChargesINR'])
                        //   } else if (disChargeEndDate != eventChargeEndDate) {
                        //     this.insertOvernightCharges(data.data[0]['OrderID'], data.data[0]['ChargesINR'])
                        //   } else {
                        //     this.insertOvernightCharges(data.data[0]['OrderID'], 0)
                        //   }

                        // } else {

                        //   if (possChargeStartDate != eventChargeStartDate && disChargeStartDate != eventChargeEndDate) {
                        //     this.insertOvernightCharges(data.data[0]['OrderID'], (data.data[0]['ChargesUSD'] + data.data[0]['ChargesUSD']))
                        //   } else if (possChargeStartDate != eventChargeStartDate && disChargeEndDate != eventChargeEndDate) {
                        //     this.insertOvernightCharges(data.data[0]['OrderID'], (data.data[0]['ChargesUSD'] + data.data[0]['ChargesUSD']))
                        //   } else if (possChargeStartDate != eventChargeStartDate) {
                        //     this.insertOvernightCharges(data.data[0]['OrderID'], data.data[0]['ChargesUSD'])
                        //   } else if (possChargeEndDate != eventChargeStartDate) {
                        //     this.insertOvernightCharges(data.data[0]['OrderID'], data.data[0]['ChargesUSD'])
                        //   } else if (disChargeStartDate != eventChargeEndDate) {
                        //     this.insertOvernightCharges(data.data[0]['OrderID'], data.data[0]['ChargesUSD'])
                        //   } else if (disChargeEndDate != eventChargeEndDate) {
                        //     this.insertOvernightCharges(data.data[0]['OrderID'], data.data[0]['ChargesUSD'])
                        //   } else {
                        //     this.insertOvernightCharges(data.data[0]['OrderID'], 0)
                        //   }
                        // }
                        // sessionStorage.removeItem('bookArray')
                        this.props.navigate('/additionalServices', { state: { CenterID: CenterID, OrderID: data.data[0]['OrderID'], ClientID: ClientID, isEdit: isEdit } })
                        this.setState({
                          OrderID: data.data[0]['OrderID']
                        })
                        sessionStorage.removeItem("bookingArray_Is_Details")
                        sessionStorage.removeItem('formFile')
                        sessionStorage.removeItem('membershipFormFileType')
                        sessionStorage.removeItem('fileName')
                        sessionStorage.removeItem('checkboxFlag')
                        sessionStorage.removeItem('dummyMembershipFlag')
                      }
                      else {
                        if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                          //after session expire.....................
                          sessionStorage.clear()
                          this.props.navigate('/normalView')
                          setTimeout(() => {
                            toast.error(data.msg, {
                              position: "top-center",
                              theme: "colored",
                              autoClose: 3000,
                              hideProgressBar: true,
                            });
                          }, 500);
                        } else {
                          this.setState({ isLoading: false })
                          toast.error(data.msg, {
                            position: "top-center",
                            theme: 'colored',
                            autoClose: 3000,
                            hideProgressBar: true,
                          })
                        }
                      }
                    })
                    .catch((e) => {
                      console.log(e);
                    });
                } else {
                  toastError("slot is not available against the Time")
                }

                //       } else {
                //         toastError("please select dismantle end Time")
                //       }
                //     } else {
                //       toastError("please select dismantle start Time")
                //     }
                //   } else {
                //     toastError("please select dismantle end Date")
                //   }
                // } else {
                //   toastError("please select dismantle start Date")
                // }

              } else {
                toastError("please select event end Time")
              }
            } else {
              toastError("please select event start Time")
            }
          } else {
            toastError("please select event end Date")
          }
        } else {
          toastError("please select event start Date")
        }

        //       } else {
        //         toastError("please select possession end Time")
        //       }
        //     } else {
        //       toastError("please select possession start Time")
        //     }
        //   } else {
        //     toastError("please select possession end Date")
        //   }
        // } else {
        //   toastError("please select possession start Date")
        // }
      }
      else {
        this.setState({ isLoading: false })
        toast.error("please enter mendetory fields!", {
          position: "top-center",
          theme: 'colored',
          autoClose: 3000,
          hideProgressBar: true,
        })
      }
    }, 100);


  }

  getBookingDetails() {
    const { OrderID, SittingArrangementList } = this.state
    const id = this.props.location.state != null && this.props.location.state.OrderID != null ? this.props.location.state.OrderID : ''
    console.log("OrderID id", id)
    this.setState({ isLoading: true })
    this.props
      .get_booking_Details_action(id)
      .then((data) => {
        if (data.error != 1) {
          // console.log("getBookingDetails ----------------------", data.data['tableData'])

          this.setState({
            comparDataWithSessionList: data.data['tableData'],
            isLoading: false,
            TypeOfEventId: data.data['data'][0]['TypeOfEventID'],
            EntryTypeId: data.data['data'][0]['EntryTypeID'],
            SittingArrangementId: data.data['data'][0]['SittingTypeID'],
            CenterID: data.data['data'][0]['CenterID'],
            NoofPAX: data.data['data'][0]['NoOfPAX'],
            DeskId: data.data['data'][0]['DeskTypeID'],
            currencyId: data.data['tableData'] != '' ? data.data['tableData'][0]['CurrencyID'] : <></>,
            CenterID: data.data['tableData'] != '' ? data.data['tableData'][0]['CenterID'] : '',
            MaxPAX: data.data['tableData'] != '' ? data.data['tableData'][0]['MaxPAX'] : '',
            formFile: data.data['data'][0]['MembershipFilePath'] != null ? data.data['data'][0]['MembershipFilePath'] : '',
            dummyFileName: data.data['data'][0]['MembershipFilePath'] != '' && data.data['data'][0]['MembershipFilePath'] != null ? data.data['data'][0]['MembershipFilePath'].split(`/document/membership/${data.data['tableData'][0]['OrderID']}/`) : null,
            // bookingList: JSON.parse(sessionStorage.getItem('bookArray')) == null ? data.data['tableData'] : JSON.parse(sessionStorage.getItem('bookArray')),
            MembershipFilePathDetails: sessionStorage.getItem('dummyMembershipFlag') == null ? data.data['data'][0]['MembershipFilePath'] != null ? data.data['data'][0]['MembershipFilePath'] : '' : '',

            // possesion
            PossesionStartDate: data.data['tableData'][0]['PossessionStartDate'] != '' && data.data['tableData'][0]['PossessionStartDate'] != null ? moment(data.data['tableData'][0]['PossessionStartDate'], 'YYYY-MM-DD').toDate() : '',
            PossesionEndDate: data.data['tableData'][0]['PossessionEndDate'] != '' && data.data['tableData'][0]['PossessionEndDate'] != null ? moment(data.data['tableData'][0]['PossessionEndDate'], 'YYYY-MM-DD').toDate() : '',
            PossesionStartTime: data.data['tableData'][0]['PossessionStartTime'] != '' && data.data['tableData'][0]['PossessionStartTime'] != null ? data.data['tableData'][0]['PossessionStartTime'] : '',
            PossesionEndTime: data.data['tableData'][0]['PossessionEndTime'] != '' && data.data['tableData'][0]['PossessionEndTime'] != null ? data.data['tableData'][0]['PossessionEndTime'] : '',

            // event
            eventStartDate: data.data['tableData'][0]['EventStartDate'] != '' && data.data['tableData'][0]['EventStartDate'] != null ? moment(data.data['tableData'][0]['EventStartDate'], 'YYYY-MM-DD').toDate() : '',
            eventEndDate: data.data['tableData'][0]['EventEndDate'] != '' && data.data['tableData'][0]['EventEndDate'] != null ? moment(data.data['tableData'][0]['EventEndDate'], 'YYYY-MM-DD').toDate() : '',
            eventStartTime: data.data['tableData'][0]['EventStartTime'] != '' && data.data['tableData'][0]['EventStartTime'] != null ? data.data['tableData'][0]['EventStartTime'] : '',
            eventEndTime: data.data['tableData'][0]['EventEndTime'] != '' && data.data['tableData'][0]['EventEndTime'] != null ? data.data['tableData'][0]['EventEndTime'] : '',

            // Dismantle
            dismantleStartDate: data.data['tableData'][0]['DismentalStartDate'] != '' && data.data['tableData'][0]['DismentalStartDate'] != null ? moment(data.data['tableData'][0]['DismentalStartDate'], 'YYYY-MM-DD').toDate() : '',
            dismantleEndDate: data.data['tableData'][0]['DismentalEndDate'] != '' && data.data['tableData'][0]['DismentalEndDate'] != null ? moment(data.data['tableData'][0]['DismentalEndDate'], 'YYYY-MM-DD').toDate() : '',
            dismantleStartTime: data.data['tableData'][0]['DismentalStartTime'] != '' && data.data['tableData'][0]['DismentalStartTime'] != null ? data.data['tableData'][0]['DismentalStartTime'] : '',
            dismantleEndTime: data.data['tableData'][0]['DismentalEndTime'] != '' && data.data['tableData'][0]['DismentalEndTime'] != null ? data.data['tableData'][0]['DismentalEndTime'] : '',
          })

          setTimeout(() => {

            if (data.data['data'][0]['SittingTypeID'] != null) {
              this.state.SittingArrangementList.map((item) => {
                if (data.data['data'][0]['SittingTypeID'] == item.SittingTypeID) {
                  item.IS_cheked = 1
                }
              })
              this.setState({ SittingArrangementList: this.state.SittingArrangementList })
            }
          }, 100);

          if (JSON.parse(sessionStorage.getItem('bookArray')) == null) {
            sessionStorage.setItem('newbookArray', JSON.stringify(data.data['tableData']))
          }

          if (data.data['data'][0]['SittingTypeID'] != '' && data.data['data'][0]['SittingTypeID'] != null) {
            this.setState({ NoOfPAXFlag: false })
          } else {
            this.setState({ NoOfPAXFlag: true, NoofPAX: '' })
          }

          data.data['data'][0]['MembershipFilePath'] == null ?
            this.setState({
              fileName: '',
              formFile: '',
              fileType: ''
            }) : <></>

          setTimeout(() => {
            this.checkedBookingArrayDateTimeCondition()
            // this.bookingArrayDateCondition()
          }, 500);

          setTimeout(() => {

            if (JSON.parse(sessionStorage.getItem('bookArray')) != null) {
              const array1 = JSON.parse(sessionStorage.getItem('bookArray')).sort((a, b) => a.CalendarID + b.CalendarID)
              const array2 = data.data['tableData'].sort((a, b) => a.CalendarID - b.CalendarID)
              // console.log("result array----------------", array1)
              // console.log("result tableData----------------", array2)
              const result = this.areArraysEqual(array1, array2)
              console.log("result ----------------", result)
              if (result == false) {
                this.bookingArrayDateCondition()
                // this.checkedBookingArrayDateTimeCondition()
              } else {
                this.setState({ bookingList: data.data['tableData'] })
              }
            } else {
              this.setState({ bookingList: data.data['tableData'] })
            }

          }, 200);


          for (let i = 0; i < data.data['tableData'].length; i++) {

            if ((data.data['tableData'].length - 1) == i) {
              this.setState({ LastDate: data.data['tableData'][i]['Date'] })
              // console.log("**********************************************", data.data['tableData'][i]['Date'])
              // this.setState({ LastDate: data.data['tableData'] != '' ? moment(data.data['tableData'][i]['Date']).format('DD-MM-YYYY') : <></> })
            }

          }

        }
        else {
          if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false })
            toast.error(data.data, {
              position: "top-center",
              theme: 'colored',
              autoClose: 3000,
              hideProgressBar: true,
            })
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  checkbox() {
    const { checkboxFlag } = this.state
    this.setState({
      checkboxFlag: !checkboxFlag,
    })
    if (checkboxFlag) {
      this.setState({
        fileName: '',
        formFile: '',
        fileType: ''
      })
    }

  }

  areArraysEqual(arr1, arr2) {
    // Check if the lengths are the same
    var condition = false

    if (arr1.length !== arr2.length) {
      condition = false
    }
    if (arr1.length == arr2.length) {
      for (let i = 0; i < arr2.length; i++) {
        if (arr1[i].CalendarID != arr2[i].CalendarID) {
          condition = false
        } else {
          condition = true
        }
      }
    }

    // If all elements are the same, arrays are similar
    return condition;
  }

  // Input Feilds Validation
  inputValidate() {
    const { TypeOfEventId, SittingArrangementId, TypeOfEventErr, SittingTypeErr } = this.state

    if (TypeOfEventId == "" || TypeOfEventId == null || TypeOfEventId == "Select") {
      this.setState({ TypeOfEventErr: 'Please select Type of event' })
    }

    if (SittingArrangementId == "" || SittingArrangementId == null || SittingArrangementId == "Select") {
      this.setState({ SittingTypeErr: 'Please select Sitting arrangement' })
    }
  }

  companyInfo() {
    const { LastDate, MaxPAX } = this.state
    const OrderID = this.props.location.state != null && this.props.location.state.OrderID != null ? this.props.location.state.OrderID : ''
    const CenterID = this.props.location.state != null && this.props.location.state.CenterID != null ? this.props.location.state.CenterID : ''
    const isEdit = this.props.location.state != null && this.props.location.state.isEdit != null ? this.props.location.state.isEdit : null
    const { ClientID } = this.state
    this.props.navigate('/companyInfo', { state: { OrderID: OrderID, CenterID: CenterID, ClientID: ClientID, LastDate: LastDate, MaxPAX: MaxPAX, isEdit, isEdit } })
    sessionStorage.removeItem("bookingArray_Is_Details")
  }

  possesionStartDatePicker(date) {
    const { bookingList, checkedPossessionFromDate, PossesionEndDate } = this.state

    const checkedDate = checkedPossessionFromDate
    console.log("checkedDate -----------------12222", checkedDate)

    if (PossesionEndDate < date) {
      this.setState({ PossesionEndDate: date })
    }

    if (checkedDate > date) {
      this.setState({ isOpen: true })
    }
    this.setState({ PossesionStartDate: date })
  }

  possesionEndDatePicker(date) {
    const { bookingList, checkedPossessionToDate } = this.state

    const checkedDate = checkedPossessionToDate

    // if (checkedDate > date) {
    //   this.setState({ isOpen: true })
    // }

    this.setState({ PossesionEndDate: date })
  }

  isDateDisabled = (date) => {
    const { slotStartDate, slotEndDate } = this.state

    return date >= slotStartDate && date <= slotEndDate;
  };


  onPossessionEndTime(e) {
    const { checkedPossessionToTime } = this.state
    const checkedTime = checkedPossessionToTime
    const value = e.target.value
    if (checkedTime < e.target.value) {
      this.setState({ isOpen2: true })
    }
    // setTimeout(() => {

    const conditionChecked = e.target.value.split(':')
    if (conditionChecked[1] == '00') {
      this.setState({ PossesionEndTime: conditionChecked[0] + ':' + '00' })
    } else if (conditionChecked[0] == '23') {
      if (conditionChecked[1] <= '59') {
        this.setState({ dismantleEndTime: '00' + ':' + '00' })
      }
    } else if (conditionChecked[1] <= '15') {
      this.setState({ PossesionEndTime: conditionChecked[0] + ':' + '15' })
    } else if (conditionChecked[1] <= '30') {
      this.setState({ PossesionEndTime: conditionChecked[0] + ':' + '30' })
    } else if (conditionChecked[1] <= '45') {
      this.setState({ PossesionEndTime: conditionChecked[0] + ':' + '45' })
    } else if (conditionChecked[1] <= '59') {
      this.setState({ PossesionEndTime: (parseInt(conditionChecked[0]) + 1) + ':' + '00' })
    } else {
      this.setState({ PossesionEndTime: '' })
    }

  }

  onPossessionStartTime(e) {
    const { checkedPossessionFromTime } = this.state
    const checkedTime = checkedPossessionFromTime
    const value = e.target.value

    if (checkedTime > value) {
      this.setState({ isOpen2: true })
    }

    const conditionChecked = e.target.value.split(':')
    if (conditionChecked[1] == '00') {
      this.setState({ PossesionStartTime: conditionChecked[0] + ':' + '00' })
    } else if (conditionChecked[0] == '23') {
      if (conditionChecked[1] <= '59') {
        this.setState({ dismantleEndTime: '00' + ':' + '00' })
      }
    } else if (conditionChecked[1] <= '15') {
      this.setState({ PossesionStartTime: conditionChecked[0] + ':' + '15' })
    } else if (conditionChecked[1] <= '30') {
      this.setState({ PossesionStartTime: conditionChecked[0] + ':' + '30' })
    } else if (conditionChecked[1] <= '45') {
      this.setState({ PossesionStartTime: conditionChecked[0] + ':' + '45' })
    } else if (conditionChecked[1] <= '59') {
      this.setState({ PossesionStartTime: (parseInt(conditionChecked[0]) + 1) + ':' + '00' })
    } else {
      this.setState({ PossesionStartTime: '' })
    }

  }

  onEventEndTime(e, index) {
    const { checkedEventToTime, eventToTimeList, bookingList } = this.state

    const value = e.target.value
    // console.log("eventToTimeList", eventToTimeList)

    // eventToTimeList.map((item, i) => {
    //   if (i === index) {
    //     if (value > item) {
    //       this.setState({ isOpen2: true })
    //     }
    //   }
    // })

    const conditionChecked = value.split(':')
    const blist = [...bookingList]

    blist.map((data, i) => {
      if (i === index) {
        // if (checkedTime < e.target.value) {
        //   this.setState({ isOpen2: true })
        // }

        if (conditionChecked[1] == '00') {
          data.EventEndTime = conditionChecked[0] + ':' + '00'
        } else if (conditionChecked[0] == '23') {
          if (conditionChecked[1] <= '59') {
            this.setState({ dismantleEndTime: '00' + ':' + '00' })
          }
        } else if (conditionChecked[1] <= '15') {
          data.EventEndTime = conditionChecked[0] + ':' + '15'
        } else if (conditionChecked[1] <= '30') {
          data.EventEndTime = conditionChecked[0] + ':' + '30'
        } else if (conditionChecked[1] <= '45') {
          data.EventEndTime = conditionChecked[0] + ':' + '45'
        } else if (conditionChecked[1] <= '59') {
          data.EventEndTime = (parseInt(data.EventEndTime) + 1) + ':' + '00'
        } else {
          data.EventEndTime = ''
        }
      }
    })

    console.log("blist-----------------------", blist)

    this.setState({ bookingList: blist })

  }

  onEventStartDate(date) {
    const { checkedEventFromDate } = this.state
    const checkedDate = checkedEventFromDate

    // if (checkedDate > date) {
    //   this.setState({ isOpen: true })
    // }
    this.setState({ eventStartDate: date })
  }

  onEventEndDate(date, value) {
    const { checkedEventToDate } = this.state
    const checkedDate = checkedEventToDate

    // if (checkedDate > date) {
    //   this.setState({ isOpen: true })
    // }

    this.setState({ eventEndDate: date })
  }

  onEventStartTime(e, index) {
    const { checkedEventToTime, eventFromTimeList, bookingList } = this.state

    const value = e.target.value
    // console.log("eventFromTimeList", eventFromTimeList)

    // eventFromTimeList.map((item, i) => {
    //   if (i === index) {
    //     if (value < item) {
    //       this.setState({ isOpen2: true })
    //     }
    //   }
    // })

    const conditionChecked = value.split(':')

    const blist = [...bookingList]

    blist.map((data, i) => {
      if (i === index) {

        if (conditionChecked[1] == '00') {
          data.EventStartTime = conditionChecked[0] + ':' + '00'
        } else if (conditionChecked[0] == '23') {
          if (conditionChecked[1] <= '59') {
            this.setState({ dismantleEndTime: '00' + ':' + '00' })
          }
        } else if (conditionChecked[1] <= '15') {
          data.EventStartTime = conditionChecked[0] + ':' + '15'
        } else if (conditionChecked[1] <= '30') {
          data.EventStartTime = conditionChecked[0] + ':' + '30'
        } else if (conditionChecked[1] <= '45') {
          data.EventStartTime = conditionChecked[0] + ':' + '45'
        } else if (conditionChecked[1] <= '59') {
          data.EventStartTime = (parseInt(data.EventStartTime) + 1) + ':' + '00'
        } else {
          data.EventStartTime = ''
        }

      }
    })


    this.setState({ bookingList: blist })

  }

  onDismantleEndTime(e) {
    const { checkedDismantleToTime } = this.state
    const checkedTime = checkedDismantleToTime

    const value = e.target.value

    if (value > checkedTime) {
      this.setState({ isOpen2: true })
    }

    const conditionChecked = value.split(':')

    if (conditionChecked[1] == '00') {
      this.setState({ dismantleEndTime: conditionChecked[0] + ':' + '00' })
    } else if (conditionChecked[0] == '23') {
      if (conditionChecked[1] <= '59') {
        this.setState({ dismantleEndTime: '00' + ':' + '00' })
      }
    } else if (conditionChecked[1] <= '15') {
      this.setState({ dismantleEndTime: conditionChecked[0] + ':' + '15' })
    } else if (conditionChecked[1] <= '30') {
      this.setState({ dismantleEndTime: conditionChecked[0] + ':' + '30' })
    } else if (conditionChecked[1] <= '45') {
      this.setState({ dismantleEndTime: conditionChecked[0] + ':' + '45' })
    } else if (conditionChecked[1] <= '59') {
      this.setState({ dismantleEndTime: (parseInt(conditionChecked[0]) + 1) + ':' + '00' })
    } else {
      this.setState({ dismantleEndTime: '' })
    }

  }

  onDismantleStartTime(e) {
    const { checkedDismantleFromTime } = this.state

    const checkedTime = checkedDismantleFromTime

    if (checkedTime > e.target.value) {
      this.setState({ isOpen2: true })
    }

    const conditionChecked = e.target.value.split(':')
    if (conditionChecked[1] == '00') {
      this.setState({ dismantleStartTime: conditionChecked[0] + ':' + '00' })
    } else if (conditionChecked[1] <= '15') {
      this.setState({ dismantleStartTime: conditionChecked[0] + ':' + '15' })
    } else if (conditionChecked[1] <= '30') {
      this.setState({ dismantleStartTime: conditionChecked[0] + ':' + '30' })
    } else if (conditionChecked[1] <= '45') {
      this.setState({ dismantleStartTime: conditionChecked[0] + ':' + '45' })
    } else if (conditionChecked[1] <= '59') {
      this.setState({ dismantleStartTime: (parseInt(conditionChecked[0]) + 1) + ':' + '00' })
    } else {
      this.setState({ dismantleStartTime: '' })
    }

  }

  onDismantleStartDate(date) {
    const { checkedDismantleFromDate, dismantleEndDate } = this.state
    const checkedDate = checkedDismantleFromDate

    if (dismantleEndDate < date) {
      this.setState({ dismantleEndDate: date })
    }

    if (checkedDate < date) {
      this.setState({ isOpen: true })
    }

    this.setState({ dismantleStartDate: date })
  }

  onDismantleEndDate(date) {
    const { checkedDismantleToDate } = this.state
    const checkedDate = checkedDismantleToDate

    if (checkedDate < date) {
      this.setState({ isOpen: true })
    }

    this.setState({ dismantleEndDate: date })
  }


  toggleModal() {
    const { isOpen } = this.state
    this.setState({ isOpen: !isOpen })
  }

  toggleModal2() {
    const { isOpen2 } = this.state
    console.log("isOpen2-----------------", isOpen2)
    this.setState({ isOpen2: false })
  }

  record() {
    const { bookingList, isOpen, currencyId, membershipFilePath, PossesionStartDate, PossesionEndDate, eventStartDate, eventEndDate, dismantleStartDate, dismantleEndDate, PossesionStartTime, PossesionEndTime, eventStartTime, eventEndTime, dismantleStartTime, dismantleEndTime, slotStartDate, slotEndDate, slotEventEndDate, MembershipFilePathDetails, CenterID, PricingList } = this.state
    bookingList != null && bookingList != '' ? bookingList.sort((a, b) => a.id - b.id) : <></>

    return (
      <div className='custom_table'>
        <div className='hack1'>
          <div className='hack2'>
            <table class="table table-bordered table-striped table-sm m-0" id="tbl" style={{ whiteSpace: "nowrap" }}>
              <thead>
                <tr>
                  <th style={{ width: '25%' }}>Date</th>
                  <th style={{ width: '25%' }}>Time Slot</th>
                  <th style={{ width: '25%' }}>Selected Hrs</th>

                  {
                    currencyId == 2 ? <th>Amount (USD) </th> : <th>Amount (INR) </th>
                  }


                  <th class="text-right">Action</th>
                </tr>
              </thead>
              <tbody>
                {
                  bookingList != null && bookingList != '' ?
                    bookingList.length > 0 ? (
                      bookingList.map((data, i) => (

                        <tr>
                          <td style={{ textAlign: 'left' }}>{data.Date != ''
                            && data.Date != null ? data.Date : <></>}</td>
                          <td style={{ textAlign: 'left' }}>{data.Timeslot}</td>
                          {/* {console.log("data.Date", data.Date)} */}
                          <td style={{ textAlign: 'left' }}>{data.SelectedHr}</td>
                          {
                            currencyId == 2 ?
                              <>
                                {(sessionStorage.getItem('fileName') != null && sessionStorage.getItem('fileName') != '') || (MembershipFilePathDetails != '' && MembershipFilePathDetails != null) ?
                                  <td style={{ textAlign: 'left' }}>{(data.NetpriceInUSD != null ? '$ ' + data.NetpriceInUSD.toLocaleString("en-IN") : '-')}&nbsp;  <del className="text-danger">{'$ ' + data.PriceInUSD.toLocaleString("en-IN")}</del> </td> :
                                  <td style={{ textAlign: 'left' }}> {(data.PriceInUSD != null ? '$ ' + data.PriceInUSD.toLocaleString("en-IN") : '-')} </td>
                                }

                              </>
                              :
                              <>
                                {(sessionStorage.getItem('fileName') != null && sessionStorage.getItem('fileName') != '') || (MembershipFilePathDetails != '' && MembershipFilePathDetails != null) ?
                                  <td style={{ textAlign: 'left' }}>{(data.NetpriceInINR != null ? '₹ ' + data.NetpriceInINR.toLocaleString("en-IN") : '-')}&nbsp; <del className="text-danger">{'₹ ' + data.PriceInINR.toLocaleString("en-IN")}</del>  </td> :
                                  <td style={{ textAlign: 'left' }}>{(data.PriceInINR != null ? '₹ ' + data.PriceInINR.toLocaleString("en-IN") : '-')} </td>
                                }
                              </>

                          }
                          {
                            (i == 0 || (bookingList.length - 1) == i) && bookingList.length > 1 ?
                              <td style={{ textAlign: 'center' }}> <a><span className="text-danger" style={{ cursor: 'pointer' }}><i className="fa fa-trash-o" onClick={(e) => this.handleDelete(e, data.CalendarID, data.Date)} /></span></a></td>
                              :
                              <td style={{ textAlign: 'center' }}>-</td>
                          }
                        </tr>
                      ))) : (<tr><td colSpan={6} className='text-center'>Record not found</td></tr>)
                    : <></>
                }

                {/* <tr>
                  <td colSpan={5}></td>
                </tr> */}
                <tr >
                  <td colSpan={3} style={{ backgroundColor: 'white', color: "#dc3545", border: 'none' }}>
                    Selected hours are inclusive of setup and dismantal hours
                  </td>
                  <td colSpan={2} style={{ backgroundColor: 'white', color: "#dc3545", textAlign: 'right', border: 'none' }}>
                    All times in 24hrs format
                  </td>
                </tr>
              </tbody>


            </table>
            <table class="table table-bordered table-striped table-sm" id="tbl" style={{ whiteSpace: "nowrap" }}>
              <thead>
                <tr>
                  <th style={{ width: '30%' }}> </th>
                  <th > Start Date <span class="mendatory_class">*</span></th>
                  <th > End Date <span class="mendatory_class">*</span></th>
                  <th > Start Time <span class="mendatory_class">*</span></th>
                  <th > End Time <span class="mendatory_class">*</span></th>
                </tr>
              </thead>
              <tbody>
                {/* {CenterID != 1 ? */}
                {/* <tr>
                  <td > Possesion Date / Time </td>
                  <td >
                    <DatePicker className="form-control datepicker-style "
                      dateFormat="dd-MM-yyyy"
                      maxDate={slotStartDate}
                      minDate={slotStartDate - 1}
                      // disabled={CenterID == 1}
                      selected={PossesionStartDate}
                      onChange={(date) => {
                        this.possesionStartDatePicker(date)
                      }}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      placeholderText="dd/mm/yyyy"
                    />
                  </td>
                  <td > <DatePicker className="form-control datepicker-style"
                    dateFormat="dd-MM-yyyy"
                    selected={PossesionEndDate}
                    maxDate={slotStartDate}
                    // disabled={CenterID == 1}
                    minDate={PossesionStartDate == '' ? slotStartDate - 1 : slotStartDate - 1 && PossesionStartDate}
                    onChange={(date) => {
                      this.possesionEndDatePicker(date)
                    }}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="dd/mm/yyyy"
                  /></td>
                  <td >
                    <TimePicker
                      className='time-picker'

                      value={PossesionStartTime}
                      onChange={(e) => this.onPossessionStartTime(e)}
                      step={60 * 15}
                      disableClock={true}

                    />
                  </td>
                  <td >
                    <TimePicker
                      isTimeDisabled={PossesionStartTime}

                      className='time-picker'
                      value={PossesionEndTime}
                      onChange={(e) => this.onPossessionEndTime(e)}
                      step={60 * 15} />
                  </td>
                </tr> */}
                {/* : <></>} */}
                {
                  bookingList != null && bookingList != '' && bookingList.length > 0 ?
                    bookingList.map((data, i) => (
                      <tr>
                        <td > Event Date / Time </td>
                        <td > <DatePicker className="form-control datepicker-style"
                          dateFormat="dd-MM-yyyy"
                          selected={moment(data.EventStartDate, 'DD/MM/YYYY').toDate()}
                          filterDate={this.isDateDisabled}
                          onChange={(date) => {
                            this.onEventStartDate(date)
                          }}
                          disabled={true}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText="dd/mm/yyyy"
                        /> </td>

                        <td > <DatePicker className="form-control datepicker-style"
                          dateFormat="dd-MM-yyyy"
                          selected={moment(data.EventEndDate, 'DD/MM/YYYY').toDate()}
                          filterDate={this.isDateDisabled}
                          disabled={true}
                          onChange={(date) => {
                            this.onEventEndDate(date)
                          }}
                          minDate={eventStartDate}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText="dd/mm/yyyy"
                        /></td>
                        <td >
                          <TimePicker
                            placeholder='hh:mm'
                            className='time-picker'
                            value={data.EventStartTime != undefined ? data.EventStartTime.replace(/\s+(?:AM|PM)/, "") : ''}
                            onChange={(e) => this.onEventStartTime(e, i, data.EventStartTime.replace(/\s+(?:AM|PM)/, ""))}
                            step={60 * 15} />
                        </td>
                        <td >
                          <TimePicker
                            placeholder='hh:mm'
                            className='time-picker'
                            value={data.EventEndTime != undefined ? data.EventEndTime.replace(/\s+(?:AM|PM)/, "") : ''}
                            onChange={(e) => this.onEventEndTime(e, i, data.EventEndTime.replace(/\s+(?:AM|PM)/, ""))}
                            step={60 * 15} />
                        </td>
                      </tr>
                    )) : <></>
                }
                {/* {CenterID != 1 ? */}
                {/* <tr>
                  <td > Dismantle Date / Time </td>

                  <td > <DatePicker className="form-control datepicker-style"
                    dateFormat="dd-MM-yyyy"
                    selected={dismantleStartDate}
                    maxDate={slotEventEndDate}
                    minDate={slotEndDate}
                    onChange={(date) => {
                      this.onDismantleStartDate(date)
                    }}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="dd/mm/yyyy"
                  /></td>
                  <td >
                    <DatePicker className="form-control datepicker-style"
                      dateFormat="dd-MM-yyyy"
                      selected={dismantleEndDate}
                      // disabled={CenterID == 1}
                      maxDate={slotEventEndDate}
                      minDate={dismantleStartDate == '' ? slotEndDate - 1 : slotEndDate - 1 && dismantleStartDate}
                      onChange={(date) => {
                        this.onDismantleEndDate(date)
                      }}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      placeholderText="dd/mm/yyyy"
                    />
                  </td>
                  <td >
                    <TimePicker
                      className='time-picker'

                      value={dismantleStartTime} onChange={(e) => this.onDismantleStartTime(e)}
                      step={60 * 15} />
                  </td>
                  <td >
                    <TimePicker
                      className='time-picker'

                      value={dismantleEndTime} onChange={(e) => this.onDismantleEndTime(e)}
                      step={60 * 15} />
                  </td>
                </tr> */}
                {/* : <></>} */}

              </tbody>


            </table>
            <tr style={{ color: "#dc3545", marginBottom: '0px' }} className='d-flex'>
              <div style={{ marginRight: '5px' }} >Note:</div>
              <div className='d-flex' style={{ flexDirection: 'column' }} >
                {(PricingList?.[1]?.['Amount_in_USD'] || PricingList?.[1]?.['Amount_in_INR']) ? <span> Kindly note that Overnight Setup & Storage charges {PricingList != '' ? currencyId == 1 ? '₹ ' + PricingList[1]['Amount_in_INR'] : '$ ' + PricingList[1]['Amount_in_USD'] : ''}/- plus Taxes will be applicable as per availability.</span> : <></>}
                {(PricingList?.[0]?.['Amount_in_INR'] || PricingList?.[0]?.['Amount_in_USD']) ? <span> Kindly note that for Every additional hour taken beyond the standard time slot {PricingList != '' ? currencyId == 1 ? '₹ ' + PricingList[0]['Amount_in_INR'] : '$ ' + PricingList[0]['Amount_in_USD'] : ''} /- plus taxes will be applicable as per availability.</span> : <></>}
              </div>
            </tr>
          </div>
        </div>
      </div >

    )
  }

  render() {
    const { isLoading, checkboxFlag, TypeOfEventId, TypeOfEventList, EntryTypeId, SittingArrangementId, DeskId, EntryTypeList, SittingArrangementList, DeskList, membership, NoofPAX, checked, bookingList, fileName, currencyId, currencyList, CenterID, MaxPAX, OrderID, modalShowTimeErr,
      modalShowDateErr, TypeOfEventErr, SittingTypeErr
    } = this.state
    console.log("TypeOfEventId RENDER", TypeOfEventId)

    return (
      <>
        {isLoading ? <Loader></Loader> : null}

        <main id="main">
          <Header data={JSON.parse(sessionStorage.getItem('Is_modify')) != true && this.state.OrderID != null && this.state.OrderID != '' ? [2, true] : [2]} />

          <section style={{ marginTop: "115px" }}>
            <div className="container-fluid">
              <div className="row">
                {(CenterID != '' && CenterID != null) && <BookingDetailsAside data={CenterID} />}
                <div class="col-md-9">
                  <div class="md-stepper-horizontal orange">
                    <Steps data={2} />
                  </div>
                  <div class="venue-booking-block" id="venue-availability-form" style={{ marginBottom: "15px" }}>
                    {/* <h5 class="guest-enquired-date mb_0">Booking Form</h5>
                                                    <hr />  */}

                    <form class="form-horizontal sky-form" role="form" autocomplete="off">

                      <div class="event_info outside_input_field">
                        {/* <div class="row"> */}

                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group floating-group floating-diff">
                              <label>Type of Event <span class="mendatory_class">*</span></label>
                              <select id="Type_of_Event" name="Entry Type" class="form-control floating-control"
                                value={TypeOfEventId}
                                onChange={(e) => this.TypeOfEventId(e)}
                              // onKeyDown={(e) => this.handleKeyDown(e)}
                              >

                                <option>Select</option>
                                {TypeOfEventList.length > 0 && TypeOfEventList.map(item => (
                                  <option
                                    key={item.TypeOfEventID}
                                    value={item.TypeOfEventID}>
                                    {item.EventName}
                                  </option>
                                ))}

                              </select>{<span className='text-danger text-start text-left d-block mt-1'>{TypeOfEventErr}</span>}
                            </div>
                          </div>

                          <div class="col-md-4">
                            <div class="form-group floating-group floating-diff">
                              <label>Currency</label>
                              <select id="Type_of_Event" name="Entry Type" class="form-control floating-control"
                                value={currencyId}
                                // onKeyDown={(e) => this.handleKeyDown(e)}
                                onChange={e => this.currencyId(e)}>
                                {currencyList.length > 0 && currencyList.map(item => (
                                  <option
                                    key={item.ID}
                                    value={item.ID}>
                                    {item.Currency}
                                  </option>
                                ))}

                              </select>
                              {console.log("currencyId*", currencyId)}
                            </div>
                          </div>
                        </div>
                        <div class="row mb-2" style={{ marginLeft: '-5px' }} >
                          <label >Seating Arrangement<span class="mendatory_class">*</span></label>
                          {<span className='text-danger text-start text-left d-block'>{SittingTypeErr}</span>}
                        </div>
                        <div class="row mb-4">
                          {SittingArrangementList.length > 0 && SittingArrangementList.map((item, i) => (
                            <div class="col-md-4">
                              <input type='radio' style={{ cursor: 'pointer' }}
                                checked={item.IS_cheked}
                                onClick={e => this.SittingArrangementId(e, i)}
                              />  {item.Name}
                            </div>
                          ))}
                        </div>


                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              {this.record()}

                            </div>
                          </div>
                        </div>



                        <div class="row">
                          <div class="col-md-12 my_buttons">
                            <button onClick={(e) => { this.companyInfo(e) }} class="btn btn-primary custom_btn Company_Info_btn">
                              <a>Step 1 <span className='hide_on_mobile_css'>: Organizer's Info</span></a>
                            </button>
                            <button disabled={bookingList == null || bookingList == ''}
                              class="btn btn-primary custom_btn Terms_and_Conditions_btn" onClick={(e) => this.handleSubmit(e)}>Step 3 <span className='hide_on_mobile_css'>: Addtional Services</span> </button>
                          </div>
                        </div>

                      </div>

                    </form>


                  </div>



                </div>
              </div>
            </div>
          </section >

        </main >
        <ToastContainer />
        <Modal show={this.state.isOpen} onHide={this.toggleModal}>
          <Modal.Header>
            {/* <Modal.Title><h4 class="">Note</h4></Modal.Title> */}
          </Modal.Header>
          <Modal.Body style={{ paddingBottom: '0px' }}>
            <div class="row">
              <div class="form-group col-md-12">
                <p><span> Kindly note that Overnight Setup & Storage charges Rs.{CenterID == 1 ? '10000' : '10000'}/- plus Taxes will be applicable as per availability.</span></p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div class="row">
              <div class="col-md-12">
                <a onClick={this.toggleModal} class="btn save_btn">OK</a>
              </div>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.isOpen2} onHide={this.toggleModal2}>
          <Modal.Header>
            {/* <Modal.Title><h4 class="">Note</h4></Modal.Title> */}
          </Modal.Header>
          <Modal.Body style={{ paddingBottom: '0px' }}>
            <div class="row">
              <div class="form-group col-md-12">
                <p> Kindly note that for Every additional hour taken beyond the standard time slot Rs {CenterID == 1 ? '2000' : '11500'} /- plus taxes will be applicable as per availability.</p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div class="row">
              <div class="col-md-12">
                <a onClick={this.toggleModal2} class="btn save_btn">OK</a>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      </>

    )
  }
}


export default withRouter(connect(null, { fill_action, booking_Details_action, get_booking_Details_action, delete_table_booking_Details_action, update_additional_hour, check_meeting_slots_action, getPriceAndTime_action })(BookingDetails));